// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Checkbox_error__31POZ{color:#c40698;font-size:.75rem;margin-bottom:.5rem}", "",{"version":3,"sources":["webpack://./src/bepaid/components/Checkbox/Checkbox.module.scss"],"names":[],"mappings":"AAAA,uBAAO,aAAa,CAAC,gBAAgB,CAAC,mBAAmB","sourcesContent":[".error{color:#c40698;font-size:.75rem;margin-bottom:.5rem}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": "Checkbox_error__31POZ"
};
export default ___CSS_LOADER_EXPORT___;
